'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { createPolymorphicComponent, Box } from '@s7/base';
import { useProps } from '@s7/styles';
import { IDENT, defaultProps } from './Badge.contract.js';
import useStyles from './Badge.styles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const _Badge = /*#__PURE__*/ forwardRef((props, ref)=>{
    const _useProps = useProps(IDENT, props, defaultProps), [{ color, radius, position, offset, inline, withBorder, disabled, zIndex, animate, children, className }, sxs] = _useProps, others = _object_without_properties_loose(_useProps[0], [
        "color",
        "radius",
        "position",
        "offset",
        "inline",
        "withBorder",
        "disabled",
        "zIndex",
        "animate",
        "children",
        "className"
    ]);
    const { label, icon } = others;
    const [classes, cx] = useStyles({
        position,
        offset,
        radius,
        inline,
        color,
        withBorder,
        withIcon: !!icon,
        withLabel: !!label,
        zIndex,
        animate
    }, sxs, IDENT);
    return /*#__PURE__*/ jsxs(Box, _extends({
        ref: ref
    }, others, {
        className: cx(classes.wrapper, className),
        children: [
            !disabled && /*#__PURE__*/ jsxs("div", {
                className: classes.root,
                children: [
                    /*#__PURE__*/ jsx("div", {
                        className: classes.icon,
                        children: icon
                    }),
                    label && /*#__PURE__*/ jsx("div", {
                        className: classes.label,
                        children: label
                    })
                ]
            }),
            children
        ]
    }));
});
const Badge = createPolymorphicComponent(_Badge);
Badge.displayName = IDENT;
var Badge$1 = Badge;

export { Badge, Badge$1 as default };
//# sourceMappingURL=Badge.js.map
